export default __webpack_public_path__ + "static/media/progress_4.6cc42339.svg";